import { Injectable } from '@angular/core';
import {ConstantsService} from "./constants.service";
import {UtilitiesService} from "./utilities.service";
import {PRODUCT_GROUP} from "../constants";

@Injectable({
    providedIn: 'root'
})
export class PartnerServicesService {

    openService: any;

    canPerformService: boolean = true;

    constructor(
        private constantsService: ConstantsService) {
        // take that linter
    }

    private checkServicesForProduct(services: any[], productId: number): boolean {
        return UtilitiesService.isNotEmpty(services)
            && services.find((service: any) => {
                let value = false;
                if (service.productId && service.partner) {
                    value = service.productId === productId && service.partner;
                } else if (service.serviceCodeDetail) { // not sure if it is safe to remove this check
                    value = service.serviceCodeDetail.productId === productId && service.serviceCodeDetail.partner;
                }
                return value;
            });
    }

    isLemonSquad(job: any): boolean {
        return this.checkServicesForProduct(job.services, this.constantsService.getProductIdValue().LEMON_SQUAD_USED_CAR_INSPECTION);
    } // isLemonSquad()

    isMbs(job: any): boolean {
        return this.checkServicesForProduct(job.services, this.constantsService.getProductIdValue().MBS_BATTERY_REPLACEMENT) || (this.checkServicesForProduct(job.services, this.constantsService.getProductIdValue().BATTERY_REPLACEMENT) && job.partnerId > 0);
    } // isMbs()

    isPartnerSpecial(job: any) {
        return this.isLemonSquad(job) || this.isMbs(job);
    } // isPartnerSpecial()

    isTowingPanelOpen() {
        return (this.openService && this.openService.productId == this.constantsService.getProductIdValue().TOWING);
    }

    isPartnerPresent(services: any[]): boolean {
        return services.some((s: any) => {
            return s.partner;
        });
    } // isPartnerPresent()

    // this method should be refactored. we pass different data types sku vs. service into this method and they don't have the same values so things can get messed up
    mbsServicePresent(skuOrService: any[] | any) {
        let services: any[] = [];
        if (!Array.isArray(skuOrService)) {
            services = [skuOrService];
        } else {
            services = skuOrService;
        }
        return (services.some((s: any) => s.productId === this.constantsService.getProductIdValue().MBS_BATTERY_REPLACEMENT) || services.some((s: any) => {
            return s.productId === this.constantsService.getProductIdValue().BATTERY_REPLACEMENT && (s.partner || (s.service && s.service.partner));
        }));
    } // mbsServicePresent()

    // this method should be refactored. we pass different data types sku vs. service into this method and they don't have the same values so things can get messed up
    thirdPartyUsedCarInspectionPresent(skuOrService: any[] | any) {
        let services: any[] = [];
        if (!Array.isArray(skuOrService)) {
            services = [skuOrService];
        } else {
            services = skuOrService;
        }
        return services.some((s: any) => s.productId === this.constantsService.getProductIdValue().LEMON_SQUAD_USED_CAR_INSPECTION);
    } // thirdPartyUsedCarInspectionPresent()

    // this method should be refactored. we pass different data types sku vs. service into this method and they don't have the same values so things can get messed up
    detailerPresent(skuOrService: any[] | any): boolean {
        let services: any[] = [];
        if (!Array.isArray(skuOrService)) {
            services = [skuOrService];
        } else {
            services = skuOrService;
        }
        return services.some((s: any) => {
            if (UtilitiesService.isNotEmpty(s.productGroup)) {
                return s.productGroup.toLowerCase() === PRODUCT_GROUP.DETAIL;
            }
            return false;
        });
    } // detailerPresent()

    tiresPresent(skuOrService: any[] | any): boolean {
        let services: any[] = [];
        if (!Array.isArray(skuOrService)) {
            services = [skuOrService];
        } else {
            services = skuOrService;
        }
        return services.some((s: any) => {
            if (UtilitiesService.isNotEmpty(s.productGroup)) {
                return s.productGroup.toLowerCase() === PRODUCT_GROUP.PARTNER || s.partner;
            }
            return false;
        });
    } // tiresPresent

    // this method should be refactored. we pass different data types sku vs. service into this method and they don't have the same values so things can get messed up
    isCombinableService(skuOrService: any, selectedServices: any[]) {
        if (!this.mbsServicePresent(skuOrService) && this.mbsServicePresent(selectedServices)) {
            return false;
        }
        else if (this.mbsServicePresent(skuOrService) && selectedServices.length > 0) {
            return false;
        }
        else if (!this.detailerPresent(skuOrService) && this.detailerPresent(selectedServices)) {
            return false;
        }
        else if ((this.detailerPresent(skuOrService) && selectedServices.length > 0)) {
            return false;
        }
        else if (!this.tiresPresent(skuOrService) && this.tiresPresent(selectedServices)) {
            return false;
        }
        else if ((this.tiresPresent(skuOrService) && selectedServices.length > 0)) {
            return false;
        }
        else {
            return true;
        }
    } // isCombinableService()

}
